import { motion } from "framer-motion";
import blkLogo from "@/assets/Blk_Logo.webp";

const Tagline = () => {
  return (
    <section className="bg-background py-16 md:py-22 px-4">
      <div className="mx-auto max-w-3xl text-center">
        <motion.img
          src={blkLogo}
          alt="Love Otherwise"
          width={640}
          height={640}
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className="mx-auto mb-6 w-48 md:w-64 h-auto"
        />
        <motion.h2
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className="text-3xl md:text-5xl font-display font-light leading-tight text-foreground"
        >
          The setting is curated.
        </motion.h2>
        <motion.h2
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8, delay: 0.2 }}
          className="mt-2 text-3xl md:text-5xl font-display italic font-light text-foreground"
        >
          The story is yours.
        </motion.h2>
        <motion.div
          initial={{ scaleX: 0 }}
          whileInView={{ scaleX: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.5 }}
          className="mx-auto mt-8 h-px w-16 bg-champagne"
        />
        <motion.p
          initial={{ opacity: 0, y: 15 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8, delay: 0.6 }}
          className="mt-8 text-base md:text-lg font-body font-light leading-relaxed text-muted-foreground max-w-2xl mx-auto"
        >
          Editorial styling. Thoughtful storytelling. A space filled with character and creative energy. This is where modern couples come to celebrate love — otherwise.
        </motion.p>
      </div>
    </section>
  );
};

export default Tagline;
